module.exports = __webpack_public_path__ + "img/preview-2.32cd0360.webp";